export default __webpack_public_path__ + "static/media/blog-fix-paver-001.948604f7.jpg";